<template>
  <div>
    <b-tabs
      v-model="selectedTab"
      vertical
      nav-wrapper-class="nav-vertical"
    >
      <b-tab>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Driver</span>
        </template>
        <driver-documents
          v-if="selectedTab === 0"
          :driver-data="driverData"
        />
      </b-tab>
      <b-tab
        :disabled="!$store.getters['drivers/currentDriver'].carId"
      >
        <template #title>
          <feather-icon
            icon="TruckIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Car</span>
        </template>
        <car-documents
          v-if="$store.getters['drivers/currentDriver'].carId && selectedTab ===1"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTab, BTabs } from 'bootstrap-vue'
import { onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import documentStoreModule from '@/views/driver/documents/documentStoreModule'
import CarDocuments from '@/views/driver/documents/CarDocuments.vue'
import DriverDocuments from '@/views/driver/documents/DriverDocuments.vue'
import useDocumentsList from '@/views/driver/documents/useDocumentsList'

export default {
  components: {
    BTab,
    BTabs,

    DriverDocuments,
    CarDocuments,
  },
  props: {
    driverData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const DOCUMENTS_APP_STORE_MODULE_NAME = 'documents'

    // Register module
    if (!store.hasModule(DOCUMENTS_APP_STORE_MODULE_NAME)) store.registerModule(DOCUMENTS_APP_STORE_MODULE_NAME, documentStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DOCUMENTS_APP_STORE_MODULE_NAME)) store.unregisterModule(DOCUMENTS_APP_STORE_MODULE_NAME)
    })
    const selectedTab = ref(0)
    const {
      fetchDocuments,
    } = useDocumentsList()
    fetchDocuments('driver', props.driverData.id)
    return {
      selectedTab,
      fetchDocuments,
    }
  },
}
</script>

<style scoped>

</style>
